import React from 'react'
import SidebarLayout from '../components/SidebarLayout'
import RiqChat from '../components/RiqChat'

function ChatPage() {
  return (
    <SidebarLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div
          style={{
            backgroundColor: '#f1f5f9', // slate-100
            padding: '1rem 1.25rem',
            borderBottom: '1px solid #e2e8f0', // gray-200
            fontSize: '1.125rem', // text-lg
            fontWeight: 600,      // font-semibold
            color: '#0f172a',     // slate-900
            borderTopLeftRadius: '0.5rem',
            borderTopRightRadius: '0.5rem',
            textAlign: 'center'   // ⬅️ Center the text
            }}
        >
          Ask Riq- Coverage Assistant
        </div>
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <RiqChat />
        </div>
      </div>
    </SidebarLayout>
  )
}

export default ChatPage
